export default "__VITE_ASSET__c84fb25b__"